export default "__VITE_ASSET__b74ef157__"